import React from 'react';
import { connect } from 'react-redux';
import type { RootState, Dispatch } from '../app/store';
import styles from './Payment.module.css';
import { useNavigate } from 'react-router-dom';

interface PayexWindow extends Window {
  payex: any
}
declare var window: PayexWindow

function Payment ({
  paymentHref,
  orderId,
  storeId,
  verifyPaymentStatus,
  paymentStatus
}: any) {
  const navigate = useNavigate()
  const paymentEl = React.useRef<any>(null)
  const [paymentStarted, setPaymentStarted] = React.useState(false)
  const paymentTimeoutRef = React.useRef<NodeJS.Timeout>(null)
  const pollingIntervalRef = React.useRef<NodeJS.Timeout>(null)

  const appendIframe = React.useCallback(() => {
    if (paymentEl.current?.children?.length > 0) {
      paymentEl?.current.removeChild(paymentEl?.current.children[0])
    }
    const script = document.createElement('script')
    script.src = paymentHref
    script.async = true
    script.onload = handlePayments

    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [paymentHref])

  React.useEffect(() => {
    if (paymentHref && paymentEl) {
      appendIframe()
    }
  }, [paymentHref, paymentEl, appendIframe])

  // React.useEffect(() => {
  //   if (paymentSuccess === 'TRUE') {
  //     verifyPayment({ orderId, storeId });
  //   } else if (paymentSuccess === 'ERROR') {
  //     verifyPayment({ orderId, storeId });
  //   }
  // }, [paymentSuccess, orderId, storeId, verifyPayment]);

  const handlePaymentCallback = React.useCallback(() => {
    if (paymentTimeoutRef.current) {
      clearTimeout(paymentTimeoutRef.current)
    }
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current)
    }
    setTimeout(() => verifyPaymentStatus({ storeId, orderId }), 1500)
  }, [storeId, orderId, verifyPaymentStatus])

  const startPolling = React.useCallback(() => {
    pollingIntervalRef.current = setInterval(() => {
      verifyPaymentStatus({ storeId, orderId })
    }, 2000)
  }, [storeId, orderId, verifyPaymentStatus])

  React.useEffect(() => {
    if (paymentStarted) {
      paymentTimeoutRef.current = setTimeout(() => {
        startPolling()
      }, 25000)

      return () => {
        if (paymentTimeoutRef.current) {
          clearTimeout(paymentTimeoutRef.current)
        }
        if (pollingIntervalRef.current) {
          clearInterval(pollingIntervalRef.current)
        }
      }
    }
  }, [paymentStarted, startPolling])

  React.useEffect(() => {
    if (paymentStatus && (paymentStatus.toLowerCase() === 'completed' || paymentStatus.toLowerCase() === 'awaitingactivity')) {
      localStorage?.removeItem('payexref')
      navigate(`/butik/${storeId}/${orderId}/tack`)
    } else if (paymentStatus && paymentStatus.toLowerCase() === 'initialized') {
      handlePaymentCallback()
    }
    // } else if (paymentStatus) {
    //   handleError(true)
    // }
  }, [paymentStatus, storeId, orderId, navigate])

  function handlePayments () {
    if (window.payex) {
      const { paymentMenu } = window.payex?.hostedView || null
      if (paymentMenu && typeof paymentMenu === 'function') {
        setPaymentStarted(true)
        paymentMenu({
          container: 'payment-frame',
          onPaymentCompleted: () => {
            handlePaymentCallback()
          },
          onPaymentFailed: () => {
            handlePaymentCallback()
          },
          onError: () => {
            handlePaymentCallback()
          },
          onPaymentMenuInstrumentSelected: () => {
            console.log('')
          },
          style: {
            button: {
              borderRadius: '5rem',
            },
          },
        }).open()
      }
    }
  }

  return (
    <div className={styles.payment}>
      <h1 className={styles.heading}>Betalning</h1>
      <div className={styles.cardFrame}>
        <div ref={paymentEl} id="payment-frame"></div>
      </div>
    </div>
  )
}

function mapState (state: RootState) {
  return {
    paymentStatus: state.order.paymentStatus,
  }
}
function mapDispatch (dispatch: Dispatch) {
  return {
    verifyPaymentStatus: dispatch.order.verifyPaymentStatus,
  }
}

export default connect(mapState, mapDispatch)(Payment)
